import { connect } from 'react-redux';

const mapStateToProps = (state: any) => ({
   notifications: state.headerState.notifications,
});

function withNotifications(DisplayComponent: any) {
   // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'notifications' implicitly has an ... Remove this comment to see the full error message
   const ComponentWithNotificationService = ({ notifications, ...passThrough }) => {
      return <DisplayComponent notifications={notifications} {...passThrough} />;
   };

   return connect(mapStateToProps)(ComponentWithNotificationService);
}

export default withNotifications;
